require('./bootstrap');
require("babel-polyfill");

window.Vue = require('vue');

Vue.prototype.$eventBus = new Vue();

import VueCookies from 'vue-cookies';

import _ from 'lodash';
import VeeValidate, { Validator } from 'vee-validate';
import $ from 'jquery';
import VueSplide from '@splidejs/vue-splide';
import VueWaypoint from 'vue-waypoint/src';
import route from './route'

Vue.use(VueCookies);
Vue.use(VueSplide);
Vue.use(VueWaypoint);

// matomo tag manager analitics script
const analitycsConsented = VueCookies.get("analytics-consent") == null ? false : (VueCookies.get("analytics-consent") == "true" ? true : false);
if (analitycsConsented) {
    // create script element and set attributes
    var _mtm = window._mtm = window._mtm || [];
    _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
    const scriptElement = document.createElement("script");
    scriptElement.setAttribute("type", "text/javascript");
    scriptElement.setAttribute("src", "https://matomo.rokus-klett.si/js/container_TvmF5UPE.js");

    document.head.prepend(scriptElement);

    // create noscript element and set attributes
    const noScriptElement = document.createElement("noscript");
    const iframeElement = document.createElement("iframe");
    iframeElement.setAttribute("src", "https://matomo.rokus-klett.si/js/container_TvmF5UPE.js");
    iframeElement.setAttribute("height", "0");
    iframeElement.setAttribute("width", "0");
    iframeElement.setAttribute("style", "display:none;visibility:hidden");
    noScriptElement.appendChild(iframeElement);
    document.body.prepend(noScriptElement);
}




Vue.use(VeeValidate, {
    events: 'change',
    locale: 'sl',
    dictionary: {
      sl: {
          messages: {
              required: () => 'Polje je obvezno',
              email: () => `Zapis e-naslova ni pravilen`,
              digits: () => 'Polje lahko vsebuje le številke (9), brez presledkov'
          }
      }
    }
});


Vue.component('cookie-consent', require('./components/CookieConsent.vue').default);
Vue.component('cookie-consent-details', require('./components/CookieConsentDetails.vue').default);
Vue.component('blog-list', require('./components/blog/BlogList.vue').default);
Vue.component('blog-single', require('./components/blog/BlogSingle.vue').default);
Vue.component('interactive-buttons', require('./components/blog/InteractiveButtons.vue').default);
Vue.component('novice-iframe', require('./components/NoviceIframe.vue').default);
Vue.component('blog-novice-iframe', require('./components/blog/BlogNoviceIframe.vue').default);
Vue.component('popup-stack', require('./components/PopupStack.vue').default);

import multiRef from './directives/MultiRef';

Vue.directive('multi-ref', multiRef);

// import PopupZeleniKviz from './components/PopupZeleniKviz.vue';


Vue.mixin({
	methods: {
		route: route
	}
});

const app = new Vue({
    el: '#app',
    created() {
        $(document).ready(() => {
            this.init();
            if (window.location.pathname === "/") {
                this.smoothScroll();
                this.showModalPrijava();
                this.addNewsRadioBtnAnimations();
                this.addNewsArrowHandling();
                this.addNewsStatusOptionsHandler();
                this.addPrednostiDropdownHandler();
                this.addNoviceModalStatusHandler();
                this.carouselMnenj();
                this.openPopupOnScroll();
                //window.addEventListener("resize", _.debounce(this.resize, 150));
            }
            if (window.location.pathname === "/blog") {
                this.openPopupAfterWait(5000);
                this.addNoviceModalStatusHandler();
                this.smoothScroll();
            }
        });
    },
    methods: {
        init() {
            const popupConsented = this.$cookies.get("site-popup-consent") == null ? false : (this.$cookies.get("site-popup-consent") == "true" ? true : false);
            if (popupConsented) {
                this.addPopups();
            }
            // morebitni ostanki cookie-jev iz prejšnjih obiskov
            const cookiesToDelete = ["_ga", "_gat", "_gid", "_fbp"];
            if (this.$cookies.get("_ga") != null) {
                cookiesToDelete.forEach(cookie => {
                    this.$cookies.remove(cookie, "/", ".izzirokus.si");
                    this.$cookies.remove(cookie, "/", "www.izzirokus.si");
                });
            }
        },
        addPopups() {
            /* vsak naslednji popup
                this.$nextTick(() => {
                    this.$root.$emit('add-popup', popupMaxtura);
                });
            */
        },
        addNoviceModalStatusHandler() {
            $("#obvestiKoBoNaVoljoModal-close, #obvestiKoBoNaVoljoModal, #prijavaNaNoviceModal").on("click", () => {
                const twoWeeks = 60*60*24*14;
                if (this.$cookies.get("site-popup-consent") == "true") {
                    document.cookie = `popup_novice=true; path=/; max-age=${twoWeeks}; Secure`;
                }
            });
        },
        openPopupOnScroll() {
            const match = document.cookie.match('(^|;)\\s*' + "popup_novice" + '\\s*=\\s*([^;]+)');
            if (this.$cookies.get("site-popup-consent") == "false" || !!match) {
                return;
            }
            let triggered = false;
            $(window).scroll(function () {
                const scroll = $(document).scrollTop()
                const correction = $(window).height() * 0.75;
                const srednjaSolaYCoord = ($("#srednja-sola-popup").offset()["top"] || 0) - correction;
                if (scroll - srednjaSolaYCoord > 0 && !triggered) {
                    $('#srednja-sola-popup').trigger('click');
                    triggered = true;
                }
            });
        },
        openPopupAfterWait(timeout) {
            const match = document.cookie.match('(^|;)\\s*' + "popup_novice" + '\\s*=\\s*([^;]+)');

            if (this.$cookies.get("site-popup-consent") == "false" || !!match) {
                return;
            }

            setTimeout(() => {
                $('#prijava-na-novice-popup').trigger('click');
            }, timeout);
        },
        showModalPrijava() {
            $('#userSuccesfullySubscribed').trigger('click');
        },
        resize() {
            const div = $('#dynamic-hero');
            const width = div.width();

            if (width > 1300) {
                div.css('height', width * 1.2917);
            }
            else {
                div.css('height', 'auto');
            }
        },
        showConsent() {
            this.$eventBus.$emit('show-consent');
        },
        smoothScroll() {
            $('.scroll-link').on('click', function(e) {
                e.preventDefault();
                let href = $(this).attr('href');
                let target = $(href).offset().top;
                $('html, body').stop().animate({scrollTop: target}, 800, 'swing', function() {});
            });
        },
        /******************* prijava na novice gumbi, checkboxi in ostalo *************** */
        addNewsRadioBtnAnimations() {
            $('.custom-radio').on('click', function(e) {
                e.preventDefault();
                // only bounce on checked
                if ($(this).hasClass("bounce")) {
                    $(this).removeClass("bounce");
                    $(this).find('input').prop("checked", false);
                } else {
                    $(this).addClass("bounce");
                    $(this).find('input').prop("checked", true);
                }
            });
        },
        addNewsArrowHandling() {
            // s klikom na puščici se toggla dropdown
            $('.arrow-wrapper.up').on('click', function(e) {
                $(this).toggleClass("hidden");
                $(".arrow-wrapper.down").toggleClass("hidden");
                $(".dropdown").toggleClass("open");
                $("#izbira-statusa").toggleClass("hidden");
            });
            $('.arrow-wrapper.down').on('click', function(e) {
                $(this).toggleClass("hidden");
                $(".arrow-wrapper.up").toggleClass("hidden");
                $(".dropdown").toggleClass("open");
                $("#izbira-statusa").toggleClass("hidden");
            });
        },
        addNewsStatusOptionsHandler() {
            $("#izbira-statusa").on("focusout", () => {
                $("#izbira-statusa").attr("readonly", true);
            });

            $('.status-options').on('click', function(e) {
                const status = $(this).text();
                // shrani opcijo v input in zapre dropdown
                $(".dropdown").toggleClass("open");
                $(".arrow-wrapper.up").toggleClass("hidden");
                $(".arrow-wrapper.down").toggleClass("hidden");
                $("#izbira-statusa").toggleClass("hidden");
                $(this).siblings().removeClass("selected");
                $(this).addClass("selected");
                if ($("#izbira-statusa").val().trim() === "Drugo") {
                    $("#izbira-statusa").attr("readonly", false);
                    $("#izbira-statusa").focus().select();
                }
            });
        },
        /******************* prednosti dropdown *************** */
        addPrednostiDropdownHandler() {
            $('.vrstica-prednosti').on('click', function(e) {
                e.preventDefault();
                // zapri morebitni odprti tekst
                $(".vrstica-prednosti").siblings().not($(this)).removeClass("clicked");
                // pomanjšaj in hkrati povečaj kliknjeno tabelo
                $(this).toggleClass("clicked");
            });
        },
        // carousel buttons
        carouselMnenj() {
            const nrOfCards = $('.carousel .izzi-card').length;
            // const cardsArray = [...new Array(nrOfCards), { "default" : 1 }].map((_, idx) => ({[idx]: idx }));
            const self = this;

            // pripnemo click handler na oba gumba
            $('#arrow-opinion-left').on('click', function(e) {
                const currentCardId = self.getCurrentCardId();
                // preveri ali gre lahko še na levo
                if (currentCardId === 0) {
                    return;
                // če mora biti levi gumb po kliku neaktiven, ga deaktiviraj
                } else if (currentCardId === 1) {
                    setTimeout(() => {
                        $(this).removeClass("active")
                     }, 1000); // .carousel transition margin-left: 1s
                // če mora biti desni gumb po kliku aktiviran, ga aktiviraj
                } else if (currentCardId === nrOfCards - 1) {
                    $('#arrow-opinion-right').addClass("active")
                }
                $("#carousel-opinion").removeClass(`card-${currentCardId}`);
                $("#carousel-opinion").addClass(`card-${currentCardId - 1}`);

            });
            $('#arrow-opinion-right').on('click', function(e) {
                const currentCardId = self.getCurrentCardId();
                if (currentCardId === nrOfCards - 1) {
                    return;
                // če mora biti desni gumb po kliku neaktiven, ga deaktiviraj
                } else if (currentCardId === nrOfCards - 2) {
                    setTimeout(() => {
                        $(this).removeClass("active");
                     }, 1000); // .carousel transition margin-left: 1s
                // če mora biti levi gumb po kliku aktiviran, ga aktiviraj
                } else if (currentCardId === 0) {
                    $('#arrow-opinion-left').addClass("active");
                }
                $("#carousel-opinion").removeClass(`card-${currentCardId}`);
                $("#carousel-opinion").addClass(`card-${currentCardId + 1}`);
            });
        },
        getCurrentCardId() {
            const getCurrrentCardNumberMatch = $('.carousel').prop("className").split(" ").join(" ").match(/.(\d)$/);
            let currentCardId = 1; // default
            // iz razreda prebermo številko trenutne kartice (carousel card-1) - dobimo -1 in 1 zato [1]
            if (getCurrrentCardNumberMatch != null && Array.isArray(getCurrrentCardNumberMatch)) {
                currentCardId = isNaN(parseInt(getCurrrentCardNumberMatch[1])) ? currentCardId : parseInt(getCurrrentCardNumberMatch[1]);
            }
            return currentCardId;
        }
    }
});
